export default __webpack_public_path__ + "static/Winuall-7cad75ed6874763aa47aee511dfc9bf5.pdf";